import { Subject } from "rxjs";
const httpStatusSubject = new Subject();
export async function fetch(input, init) {
    const compoundInit = {
        credentials: "include",
        ...init
    };
    if (compoundInit.headers instanceof Headers) {
        if (!compoundInit.headers.has("Accept")) {
            compoundInit.headers.set("Accept", "application/json");
        }
        if (!compoundInit.headers.has("Content-Type") && (init === null || init === void 0 ? void 0 : init.body)) {
            compoundInit.headers.set("Content-Type", "application/json;charset=UTF-8");
        }
    }
    else {
        const defaultHeaders = {
            "Accept": "application/json",
        };
        if (init === null || init === void 0 ? void 0 : init.body) {
            defaultHeaders["Content-Type"] = "application/json;charset=UTF-8";
        }
        compoundInit.headers = {
            ...defaultHeaders,
            ...compoundInit.headers,
        };
    }
    const response = await window.fetch(input, compoundInit);
    httpStatusSubject.next(response.status);
    const text = await response.text();
    let body = undefined;
    if (text) {
        body = JSON.parse(text);
    }
    if (!response.ok) {
        throw new ResponseCodeError(response.status, body === null || body === void 0 ? void 0 : body.errorType, body === null || body === void 0 ? void 0 : body.errorMessage, body);
    }
    return body;
}
export class ResponseCodeError extends Error {
    constructor(status, errorType, errorMessage, body) {
        super();
        this.status = status;
        this.errorType = errorType;
        this.errorMessage = errorMessage;
        this.body = body;
    }
    static getMessage(err, defaultMessage) {
        return (err instanceof ResponseCodeError && err.errorMessage) || defaultMessage;
    }
}
export function observeHttpStatus(listener) {
    return httpStatusSubject.subscribe(listener);
}
